var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 231,
    height: 57,
    viewBox: "0 0 231 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6358",
    "data-name": "Path 6358",
    d: "M0,0H10.629C21.553,0,26.547,4.084,26.547,14.476c0,7.336-2.165,11.42-7.726,13.18,6.2,1.443,8.611,5.453,8.611,12.96C27.433,51.816,22.365,57,11.269,57H0ZM10.53,24.453c5.806,0,8.464-2.812,8.464-8.876,0-6.553-2.46-8.8-8.464-8.8h-2.8v17.68Zm-.221,25.284c6.668,0,9.374-1.932,9.374-9.194s-2.731-9.781-9.251-9.781H7.726V49.713Z",
    fill: "#0f2d47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6359",
    "data-name": "Path 6359",
    d: "M20.86,0H43.791V6.871H28.586V23.817H42.511v6.8H28.586V49.884H43.791V57H20.86Z",
    transform: "translate(30.541)",
    fill: "#0f2d47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6360",
    "data-name": "Path 6360",
    d: "M51.664,0H58.9L72.331,57h-7.8L61.8,45.825H48.687L46.029,57h-7.8ZM50.138,39.418H60.423L55.28,14.672Z",
    transform: "translate(55.981)",
    fill: "#0f2d47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6361",
    "data-name": "Path 6361",
    d: "M61,0h7.16L83.365,39.589V0h7.381V57H83.365L68.209,17.117V57H61Z",
    transform: "translate(89.318)",
    fill: "#0f2d47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6362",
    "data-name": "Path 6362",
    d: "M100.52,6.8H84.577V0h26.474L92.623,49.884h16.829V57H81.92Z",
    transform: "translate(119.949)",
    fill: "#0f2d47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a3d8e1fc7f9b72a131f559585945b245.svg";
export { ForwardRef as ReactComponent };